import React from 'react'
import CreatePayoutsContainer from 'containers/panel/reseller/create-payouts-container'

const CreatePayoutsPage = () => {
  return (
    <CreatePayoutsContainer/>
  )
}

export default CreatePayoutsPage